/// <reference path="../../app.js" />
import React, { Component } from 'react';
import '../../components/css/popupstyle.css';
import { userService } from '../../_services';
import $ from 'jquery';

class ChangePassword extends Component {
    constructor(props) {
        super(props);
        this.state = {
            header: 'Reset Password',
            userdata: JSON.parse(localStorage.getItem('user')),
            loader: false,
            error: '',
            submitted: false,
            newpwd: '',
            confirmpwd: ''
        };
        this.handleChange = this.handleChange.bind(this);
        this.handleSubmit = this.handleSubmit.bind(this);
     
    }
    handleChange(e) {
        $(document).ready(function () {
            $('.Error').removeClass('success');
        });
        const { name, value } = e.target;
        this.setState({ [name]: value, error:'' });
        $('#newpwd').removeClass('errorIcon');
        $('#confirmpwd').removeClass('errorIcon');
    }
    handleSubmit(e) {
        this.setState({ error: '', loader: true });
        try {
            $('#newpwd').removeClass('errorIcon');
            $('#confirmpwd').removeClass('errorIcon');
            $(document).ready(function () {
                $('.Error').removeClass('success');
            });
            e.preventDefault();

            this.setState({ submitted: true });
            const { newpwd, confirmpwd } = this.state;
            let IsErrorExists = false;

            if (!(newpwd) && !(confirmpwd)) {
                $('#newpwd').addClass('errorIcon');
                $('#confirmpwd').addClass('errorIcon');
                this.setState({ loader: false, error: 'New password and Confirm new password required' });
                IsErrorExists = true;
            } else if (userService.ValidateSpace(newpwd)){
                this.setState({ error: 'Space not acceptable', loader: false });
                $('#newpwd').addClass('errorIcon');
                IsErrorExists = true;
            } else if (!(newpwd)) {
                $('#newpwd').addClass('errorIcon');
                this.setState({ loader: false, error: 'New password is required' });
                IsErrorExists = true;
            } else if (newpwd.length < 8) {
                this.setState({ error: 'Password must be at least 8 characters', loader: false });
                $('#newpwd').addClass('errorIcon');
                IsErrorExists = true;
            } else if (!(confirmpwd)) {
                $('#confirmpwd').addClass('errorIcon');
                this.setState({ loader: false, error: 'Confirm new password is required' });
                IsErrorExists = true;
            } else if (newpwd != confirmpwd) {
                this.setState({ error: 'New Password and Confirm Password must match', loader: false });
                $('#confirmpwd').addClass('errorIcon');
                IsErrorExists = true;
            }
            if (IsErrorExists == true) {
                return;
            }

            // api call function
             this.Resetpassword(this.props.userEmail, this.props.userName, this.props.dataId, this.props.wholesalerName, newpwd);
        }
        catch (error) {
        }
    }
    Resetpassword(UserEmail, UserName, UserId, WholeSaler, NewPassword) {
        try {
            const requestOptions = {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({ UserEmail, UserName, UserId, WholeSaler, NewPassword })
            };
            return fetch(`/api/user/ResetWhAccountPwd`, requestOptions)
                .then(this.handleResponse)
                .then(apidata => {
                    try {
                        if (apidata.length > 0) {
                            if (apidata[0].status_code == "1") {
                                this.setState({ error: apidata[0].status_message, loader: false });
                                setTimeout(() => {
                                    this.cancelPopup()
                                }, 1500);
                            } else {
                                this.setState({ error: 'Whoops, something went wrong. Please try again', loader: false });
                            }
                        } else {
                            this.setState({ error: 'Whoops, something went wrong. Please try again', loader: false });
                        }
                    }
                    catch (error) {
                        this.setState({ error: 'Whoops, something went wrong. Please try again', loader: false });
                    }
                });
        }
        catch (error) {
        }

    }
    handleResponse(response) {
        return response.text().then(text => {
            const data = text && JSON.parse(text);
            return data;
        });
    }
    cancelPopup = () => {
        this.props.closeResetPasswordPopup();
        this.props.openManageEmailPopup(this.props.dataId, this.props.wholesalerId, this.props.wholesalerName, this.props.activeManageEmailPagin);  
    }

    render() {
        const { newpwd, confirmpwd, submitted, loader, error } = this.state;
        return (
            <div className='popup'>
                <div className='popup_inner myinfo referral change-password'>
                    <div className='new-back'>
                    <h1>{this.state.header}<button onClick={this.props.closeResetPasswordPopup}>X</button></h1>
                    <div className="referralPopup">
                        <form autocomplete="off">
                            <div className="form-group">
                                <label>New Password</label>
                                <input type="password" id="newpwd" className="form-control" name="newpwd" placeholder={newpwd} value={newpwd} onChange={this.handleChange} autoComplete="off" maxlength="16" minLength="8"  />
                            </div>
                            <div className="form-group">
                                <label>Confirm New Password</label>
                                <input type="password" id="confirmpwd" className="form-control" name="confirmpwd" placeholder={confirmpwd} value={confirmpwd} onChange={this.handleChange} autoComplete="off" maxlength="16" minLength="8"  />
                            </div>
                            <div className="form-group">
                                { loader &&
                                    <div className="theme-loader delete-loader passoword"></div>
                                }
                                <div className="pop-btn">
                                    <input onClick={this.handleSubmit} type="submit" value="Submit" className="btn" />
                                    <input onClick={this.cancelPopup} type="button" value="Cancel" className="btn cancel" />
                                </div>
                            </div>
                            {error &&
                                <div className="help-block gap">{error}</div>
                            }
                        </form>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

export default ChangePassword;